import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import FormLayout from 'src/layouts/form';
// components
import { LoadingScreen } from 'src/components/loading-screen';
// import InvoiceDownloadPage from 'src/components/trainings/InvoiceDownloadPage';
// ----------------------------------------------------------------------

const DashboardLayoutStore = lazy(() =>
  import('src/layouts/dashboard/layout').then((module) => ({ default: module.DashboardLayoutStore }))
);
const AccessLogs = lazy(() => import('src/pages/accesslogs/accesslogs'));
const TokenApi =  lazy(() => import('src/pages/accesslogs/tokenApi'));

// ----------------------------------------------------------------------

export const AccessLogsRoutes = [
  {
    path: 'authentification',
    element: (
      <AuthGuard allowedRoles={['administrator']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { element: <AccessLogs />, index: true },
      { path: 'token', element: <TokenApi /> },
    ],
  },
];


